/**
 * リスク等級（RiskGrade）
 *
 * HARC API はリスクタイプごとに異なるスケールの生値を返す。
 * このモジュールは生値をそのまま保持したうえで、
 * 表示・比較に使うリスク等級（none / caution / warning）に変換する。
 *
 * | API               | 生値        | 等級                          |
 * |-------------------|-------------|-------------------------------|
 * | FrostRisk         | 0, 2, 3     | none, caution, warning        |
 * | WindDamageRisk    | 0, 2, 3     | none, caution, warning        |
 * | HeavyRainRisk     | 0, 2, 3     | none, caution, warning        |
 * | SoilCrustingRisk  | 0, 20, 30   | none, caution, warning        |
 * | DIV (褐斑病)       | 0, 1, 2     | none, caution, warning        |
 */

/** リスク等級（安全・注意・警戒の3段階） */
export type RiskGrade = 'none' | 'caution' | 'warning';

/**
 * HARC API の生リスク値をリスク等級に変換する
 * @param riskType リスク種類（frost, wind, heavy_rain, crust, div）
 * @param rawValue HARC API の生リスク値
 * @returns 変換後のリスク等級
 */
export function getRiskGrade(riskType: string, rawValue: number): RiskGrade {
  if (rawValue === 0) return 'none';

  switch (riskType) {
    case 'frost':
    case 'wind':
    case 'heavy_rain':
      // 0=安全, 2=注意, 3=警戒
      if (rawValue === 2) return 'caution';
      if (rawValue === 3) return 'warning';
      return 'none';

    case 'crust':
      // 0=安全, 20=注意, 30=警戒
      if (rawValue === 20) return 'caution';
      if (rawValue === 30) return 'warning';
      return 'none';

    case 'div':
      // 0=安全（DIV<3）, 1=リスク小・注意（3<=DIV<6）, 2=リスク大・警戒（6<=DIV）
      if (rawValue === 1) return 'caution';
      if (rawValue >= 2) return 'warning';
      return 'none';

    default:
      return 'none';
  }
}
